
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Events } from './events';


@Injectable({
  providedIn: 'root'
})
export class UserData {
  favorites: string[] = [];
  HAS_LOGGED_IN = 'username'//'hasLoggedIn';
  HAS_SEEN_TUTORIAL = 'hasSeenTutorial';
  private username;
  private user:any={}
  constructor(
    public storage: Storage,
    private events:Events
  ) { }

  hasFavorite(sessionName: string): boolean {
    return (this.favorites.indexOf(sessionName) > -1);
  }

  addFavorite(sessionName: string): void {
    this.favorites.push(sessionName);
  }

  removeFavorite(sessionName: string): void {
    const index = this.favorites.indexOf(sessionName);
    if (index > -1) {
      this.favorites.splice(index, 1);
    }
  }

  // login(username: string): Promise<any> {
  //   return this.storage.set(this.HAS_LOGGED_IN, true).then(() => {
  //     this.setUsername(username);
  //     return window.dispatchEvent(new CustomEvent('user:login'));
  //   });
  // }

  // signup(username: string): Promise<any> {
  //   return this.storage.set(this.HAS_LOGGED_IN, true).then(() => {
  //     this.setUsername(username);
  //     return window.dispatchEvent(new CustomEvent('user:signup'));
  //   });
  // }

  // logout(): Promise<any> {
  //   return this.storage.remove(this.HAS_LOGGED_IN).then(() => {
  //     return this.storage.remove('username');
  //   }).then(() => {
  //     window.dispatchEvent(new CustomEvent('user:logout'));
  //   });
  // }

  setUsername(username: string){//: Promise<any> {
    // return this.storage.set('username', username);
    this.username = username;
    console.warn("TODO setUserInfo ")
    // localStorage.setItem('voipboxIonAppUsername', username);//TODO remove localStorage.setItem voipboxIonAppUsername
    this.events.publish("user-update")
  }

  getUsername(): any{//Promise<string> {
    // return this.storage.get('username').then((value) => {
    //   return value;
    // });
    return this.username;
  }
  setUserInfo(user: any){//: Promise<any> {
    // return this.storage.set('username', username);
    this.user = user
    console.warn("TODO setUserInfo ")
    // localStorage.setItem('voipboxIonAppPassword', user.password);//TODO remove localStorage.setItem voipboxIonAppPassword
    // localStorage.setItem('voipboxIonAppInfo', JSON.stringify(user));
    this.events.publish("user-update")
  }
  getUserInfo(field: string){//: Promise<any> {
    // return this.storage.set('username', username);
    return this.user[field]
  }
  getUserCredit(){
    // return this.secondsToHms(this.user["credit"]);
    return this.user["credit"];

  }
  private secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = ((h==0)? "0":"") + h + ":";
    var mDisplay = ((m==0)? "0":"") + m + ":";
    var sDisplay = ((s==0)? "0":"") + s ;
    return hDisplay + mDisplay + sDisplay; 
}
  isLoggedIn(): Promise<boolean> {
    return this.storage.get(this.HAS_LOGGED_IN).then((value) => {
      return value === true;
    });
  }

  checkHasSeenTutorial(): Promise<string> {
    return this.storage.get(this.HAS_SEEN_TUTORIAL).then((value) => {
      return value;
    });
  }
}
